import React from "react";
import { CtaButton } from "./CtaButton";
import { images } from "../data/landing";
export function Author() {
  return <section className="bg-navy px-4 py-16 sm:py-20" aria-labelledby="author" data-id="element-19" data-mp="oil4pk6v8kv1">
      <div className="mx-auto max-w-5xl md:grid md:grid-cols-[0.9fr_1.1fr] md:items-center md:gap-12" data-id="element-20" data-mp="9tonawix5vhr">
        <div className="relative mx-auto max-w-sm md:max-w-none" data-id="element-21" data-mp="er6uoihag2nn">
          <img src={images.author} alt="Ryan Carter, creator of the Blueprint" className="w-full rounded-3xl object-cover" loading="lazy" data-id="element-22" data-mp="12hkq8iz30jmz" />
          <div className="absolute -bottom-4 left-4 right-4 rounded-2xl bg-gold px-4 py-3 text-center" data-id="element-23" data-mp="17fm7cycy68vt">
            <p className="font-display text-2xl font-extrabold uppercase leading-none text-ink" data-id="element-24" data-mp="silid2m54s11">Ryan Carter</p>
            <p className="mt-1 text-[13px] font-semibold text-ink" data-id="element-25" data-mp="xgwrfb4m2yi7">Creator of the Blueprint™</p>
          </div>
        </div>

        <div className="mt-12 md:mt-0" data-id="element-26" data-mp="3dbyqcdodmy7x">
          <h2 id="author" className="font-display text-[34px] font-extrabold uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-27" data-mp="3i8yugj1o1qwe">
            About <span className="text-cyan" data-id="element-28" data-mp="1tz3o0kv2ezgi">Ryan Carter</span>
          </h2>
          <div className="mt-5 space-y-4 text-[16px] leading-relaxed text-mist" data-id="element-29" data-mp="1p0iqwub40vwa">
            <p className="font-semibold text-white" data-id="element-30" data-mp="22zrv0vm1jzjw">
              Orthopedic test interpretation involves more than memorizing individual examination procedures.
            </p>
            <p data-id="element-31" data-mp="2cxfzwedd2nfs">
              It requires understanding what a test is intended to assess, recognizing its limitations, and considering
              the result alongside the patient's history and the wider clinical presentation.
            </p>
            <p data-id="element-32" data-mp="2logc16helkqe">
              The Orthopedic Test Interpretation Blueprint™ organizes selected orthopedic test references, comparison
              frameworks, visual reasoning tools, and educational case exercises into six structured volumes.
            </p>
            <p data-id="element-33" data-mp="2qp2xqimyc40o">
              The goal is to provide physiotherapists with a consistent digital reference for studying orthopedic tests
              and reviewing the principles involved in interpreting their findings.
            </p>
          </div>
        </div>
      </div>
      <CtaButton className="mt-12" label="Start interpreting with clarity" data-id="element-34" data-mp="1saxbqreqvffk" />
    </section>;
}